<template>
  <div class="setup-plan-rubetek-rv3434">
    <div class="setup-plan-rubetek-rv3434__actions setup-plan-rubetek-rv3434__actions--top">
      <div class="setup-plan-rubetek-rv3434__actions-left">
        <v-btn color="primary" class="text-none" rounded @click="savePlan()">
          <v-icon left>mdi-content-save-outline</v-icon>
          Сохранить
        </v-btn>
        <v-btn color="primary" outlined rounded class="text-none ml-2" @click.prevent="returnDoorphone()">
          <v-icon left>mdi-close</v-icon>
          Отменить
        </v-btn>
      </div>
      <v-spacer />
      <div class="setup-plan-rubetek-rv3434__actions-right" v-if="changeableDiapazon">
        <v-btn
          v-if="$checkPermission('import_rules')"
          @click.stop="dialog = true"
          color="primary"
          outlined
          class="text-none rounded"
        >
          <v-icon left>mdi-import</v-icon>
          Импортировать
        </v-btn>
        <v-dialog v-model="dialog" persistent max-width="570" content-class="dialog-border-radius">
          <v-card>
            <v-card-title class="headline">Импортируя, вы сотрёте существующий план набора в базе данных,
              а так же пропадут sip данные зарегистрированных пользователей.</v-card-title>
            <v-card-text>Подтверждая, вы импортируете план набора.</v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" outlined class="text-none rounded" @click.prevent="importRulesDialog()">Отменить</v-btn>
              <v-btn color="primary" class="text-none rounded" dark @click.prevent="importRulesData()">
                <v-icon left small>mdi-import</v-icon>
                Импортировать
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn color="primary" class="text-none rounded ml-2" dark @click="addPlan">
          <v-icon left>mdi-plus</v-icon>
          Добавить
        </v-btn>
      </div>
    </div>
    <v-data-table
      ref="planTable"
      class="table"
      :headers="headersPlanRubetekRV3434"
      :items="modifiedPlan"
      :disable-sort="true"
      :footer-props="{
          showFirstLastPage: true,
        }"
    >
      <template v-slot:item.actions="{ item }">
        <div class="setup-plan-rv3434__row-actions">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                class="setup-plan-rv3434__action-btn setup-plan-rv3434__action-btn--analog btn__icon"
                :disabled="!item.Prefix || loadingApartmentAnalog != null"
                :loading="loadingApartmentAnalog === Number(item.Prefix)"
                @click.stop="openApartmentAnalogSettings(item)"
              >
                <v-icon size="22">mdi-phone-settings</v-icon>
              </v-btn>
            </template>
            <span>Настройки аналоговой линии квартиры</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                class="btn__icon"
                width="18"
                @click.stop="$set(warningDialog, item.Login, true)"
                :disabled="roleName !== 'admin'"
              >
                <v-icon>mdi-home-lock-open</v-icon>
              </v-btn>
            </template>
            <span>Код открытия</span>
          </v-tooltip>

        <v-dialog v-model="warningDialog[item.Login]" max-width="400px" content-class="dialog-border-radius">
          <v-card>
            <v-card-title class="headline">Предупреждение</v-card-title>
            <v-card-text class="text-body-2">
              При получении кода, он будет действителен в течение часа, после он автоматически обновится.
              Если домофон не в сети, код попадет в отложенную задачу и будет выполнен позже.
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" text @click="openDialog(item)">Посмотреть код</v-btn>
              <v-btn text @click="$set(warningDialog, item.Login, false)">Отмена</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCode[item.Login]" max-width="650px" content-class="dialog-border-radius">
          <v-card>
            <v-progress-linear
              v-if="loadingCode"
              indeterminate
              color="primary"
              height="3"
              class="mt-2"
            ></v-progress-linear>
            <v-card-title class="headline">
              <v-icon left color="primary">mdi-key</v-icon>
              Код открытия двери
            </v-card-title>
            <p class="text-body-2 pa-2 ml-4">
              Этот код клиент может получить в приложении, нажав на кнопку <strong>"Гостевой доступ"</strong>.
            </p>

            <p class="text-body-2 pa-2 ml-4">
              При получении кода клиентом, код будет действителен в течение часа.
              Если в момент получения кода домофон не будет в сети, запрос на обновление кода попадет в отложенную задачу
              и будет выполнен позже, когда домофон будет в сети.
            </p>

            <p class="text-body-2 pa-2 ml-4">
              Если у домофона есть связанные устройства (калитки или дополнительные входы), код также будет обновлен и для них.
              Кроме того, предоставленный клиенту код будет работать и на всех связанных устройствах.
            </p>

            <v-card-text>
              <h4 v-if="!loadingCode">Индивидуальный код открытия двери - <span style="color: black">{{ doorCode }}</span></h4>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn text color="grey" @click="closeDialog(item.Login)">Закрыть</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

          <v-icon
            class="setup-plan-rv3434__delete-icon"
            :disabled="disableDelete"
            @click="deleteItem(item.Prefix)"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
      <template v-slot:item.Prefix="{ item }">
        <v-text-field
          v-model='item.Prefix'
          class='mt-4'
          solo
          type="number"
          outlined
          dense
          flat
          :disabled="disableApartment"
        >
        </v-text-field>
      </template>
      <template v-slot:item.Comment="{ item }">
        <v-text-field
          v-model='item.Comment'
          class='mt-4'
          solo
          type="text"
          outlined
          dense
          flat
          :disabled="disableComment"
        >
        </v-text-field>
      </template>
      <template v-slot:item.Login="{ item }">
        <v-text-field
          v-model='item.Login'
          class='mt-4'
          solo
          type="text"
          outlined
          dense
          flat
          :disabled="disableLogin"
        >
        </v-text-field>
      </template>
      <template v-slot:item.IsActive="{ item }">
        <v-checkbox
          v-model='item.IsActive'
          class='mt-4'
          :label="item.IsActive ? 'Включено' : 'Выключен'"
          type="checkbox"
          :disabled="disableActivity"
        >
        </v-checkbox>
      </template>
    </v-data-table>
    <div class="setup-plan-rubetek-rv3434__actions setup-plan-rubetek-rv3434__actions--bottom mt-3">
      <v-btn color="primary" class="text-none" rounded @click="savePlan()">
        <v-icon left>mdi-content-save-outline</v-icon>
        Сохранить
      </v-btn>
      <v-btn color="primary" outlined rounded class="text-none ml-2" @click.prevent="returnDoorphone()">
        <v-icon left>mdi-close</v-icon>
        Отменить
      </v-btn>
    </div>

    <AnalogLineApartmentSettingsModal
      v-model="apartmentAnalogDialogOpen"
      :doorphone-id="$route.params.id"
      :apartment="selectedApartmentAnalog"
      :initial-data="apartmentAnalogInitialData"
      :can-save="canUpdateApartmentAnalogSettings"
      @input="onApartmentAnalogDialogInput"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { headersPlanRubetekRV3434 } from '../../../consts';
import AnalogLineApartmentSettingsModal from '../../AnalogLineApartmentSettingsModal.vue';
import { unwrapApartmentAnalogSettings } from '../../apartmentAnalogLineConsts';

export default {
  name: 'SetupPlanRubetekRV3434',
  components: { AnalogLineApartmentSettingsModal },
  data: () => {
    return {
      modifiedPlan: [],
      dialog: false,
      disableApartment: true,
      disableRules: true,
      disableActivity: true,
      disableLogin: true,
      disableComment: true,
      disableDelete: true,
      changeableDiapazon: false,
      headersPlanRubetekRV3434,
      warningDialog: {},
      loadingCode: false,
      dialogCode: {},
      doorCode: '',
      newDoorCode: '',
      apartmentAnalogDialogOpen: false,
      selectedApartmentAnalog: null,
      apartmentAnalogInitialData: null,
      loadingApartmentAnalog: null,
    };
  },
  computed: {
    ...mapGetters({
      recruitmentPlan: 'Doorphone/rules',
      doorphone: 'Doorphone/doorphone',
      roleName: 'roleName',
      rules: 'Doorphone/rules',
      doorphoneEditInfo: 'Doorphone/doorphoneEditInfo',
    }),
    canUpdateApartmentAnalogSettings () {
      return this.$checkPermission('update_analog_line_apartment_settings');
    },
  },
  created () {
    this.getRules(this.$route.params.id)
      .then(() => {
        if (this.recruitmentPlan !== undefined) {
          this.modifiedPlan = JSON.parse(JSON.stringify(this.recruitmentPlan));
        }
      });
    switch (this.roleName) {
      case 'admin': case 'agent':
        this.changeableDiapazon = true;
        this.disableApartment = false;
        this.disableComment = false;
        this.disableActivity = false;
        this.disableLogin = false;
        this.disableRules = false;
        this.disableDelete = false;
        break;
      case 'admin-engineer':
        this.disableApartment = false;
        this.disableComment = false;
        this.disableActivity = false;
        this.disableLogin = false;
        this.changeableDiapazon = true;
        this.disableRules = false;
        break;
      case 'manager':
        this.disableComment = false;
        this.disableLogin = false;
        this.disableActivity = false;
        break;
      case 'master' :
        this.disableApartment = false;
        this.disableComment = false;
        this.disableLogin = false;
        this.changeableDiapazon = true;
        this.disableDelete = true;
        this.disableActivity = true;
    }
  },
  methods: {
    ...mapActions({
      updateRules: 'Doorphone/updateRules',
      getRules: 'Doorphone/getRules',
      importRules: 'Doorphone/importRules',
      getCodeApartment: 'Doorphone/getCodeApartment',
      setCodeApartment: 'Doorphone/setCodeApartment',
      getAnalogLineApartmentSettings: 'Doorphone/getAnalogLineApartmentSettings',
    }),
    returnDoorphone () {
      this.$router.push({ name: 'DetailDoorphone', params: { id: this.$route.params.id } });
    },
    getApiErrorMessage (err, fallback) {
      return err?.response?.data?.error || err?.response?.data?.message || fallback;
    },
    onApartmentAnalogDialogInput (open) {
      this.apartmentAnalogDialogOpen = open;
      if (!open) {
        this.apartmentAnalogInitialData = null;
        this.selectedApartmentAnalog = null;
      }
    },
    async openApartmentAnalogSettings (item) {
      const apartment = Number(item.Prefix);
      if (!item.Prefix || Number.isNaN(apartment)) {
        this.$flash_warning('Укажите номер квартиры');
        return;
      }

      this.loadingApartmentAnalog = apartment;
      try {
        const payload = await this.getAnalogLineApartmentSettings({
          id: this.$route.params.id,
          apartment,
        });
        if (payload?.status === false) {
          this.$flash_warning(payload.error || 'Не удалось загрузить настройки квартиры');
          return;
        }
        this.selectedApartmentAnalog = apartment;
        this.apartmentAnalogInitialData = unwrapApartmentAnalogSettings(payload);
        this.apartmentAnalogDialogOpen = true;
      } catch (err) {
        console.error(err);
        this.$flash_warning(
          this.getApiErrorMessage(err, 'Не удалось загрузить настройки квартиры'),
        );
      } finally {
        this.loadingApartmentAnalog = null;
      }
    },
    openDialog (item) {
      this.$set(this.dialogCode, item.Login, true);
      this.$set(this.warningDialog, item.Login, false);
      this.getCode(item);
    },
    closeDialog (login) {
      this.$set(this.dialogCode, login, false);
      this.$set(this.warningDialog, login, false);
      this.doorCode = null;
    },
    getCode (item) {
      this.loadingCode = true;
      this.getCodeApartment({
        id: this.$route.params.id,
        number: item.Prefix,
      })
        .then(data => {
          this.doorCode = data.code;
        })
        .catch(() => {
          this.$flash_warning('Ошибка получения кода.');
        })
        .finally(() => {
          this.loadingCode = false;
        });
    },
    setCode (item) {
      this.loadingCode = true;
      this.setCodeApartment({
        id: this.$route.params.id,
        number: item.Prefix,
      })
        .then(data => {
          this.newDoorCode = data.newCode;
          this.doorCode = this.newDoorCode;
          this.$flash_success('Индивидуальный код успешно сгенерирован и добавлен клиенту.');
        })
        .catch(() => {
          this.$flash_warning('Ошибка изменения кода. Возможно устройство не в сети.');
        })
        .finally(() => {
          this.loadingCode = false;
        });
    },
    deleteItem (id) {
      this.modifiedPlan = this.modifiedPlan
        .filter(plan => plan.Prefix !== id)
        .map((plan, index) => ({ ...plan, Prefix: index + 1 }));
    },
    addPlan () {
      this.modifiedPlan = [...this.modifiedPlan,
        {
          Prefix: this.modifiedPlan.length + 1,
          IsActive: false,
          comment: '',
          login: '',
        },
      ];
      this.$refs.planTable.$el.children[0].scrollTop = this.$refs.planTable.$el.children[0].children[0].clientHeight;
      this.$flash_success('Ячейка добавлена в конец списка');
    },
    importRulesData () {
      this.importRules(this.$route.params.id)
        .then(importRules => {
          this.$flash_success('Импортирование успешно завершено');
          this.dialog = false;
          this.getRules(this.$route.params.id)
            .then(() => {
              this.modifiedPlan = JSON.parse(JSON.stringify(this.recruitmentPlan));
            });
        })
        .catch(() => {
          this.$flash_warning('Ошибка импортирования');
        });
    },
    importRulesDialog () {
      this.dialog = false;
    },
    savePlan () {
      const dataRules = [];
      for (let i = 0; i < this.modifiedPlan.length; i++) {
        dataRules.push({
          prefix: this.modifiedPlan[i].Prefix,
          IsActive: this.modifiedPlan[i].IsActive,
          login: this.modifiedPlan[i].Login,
          comment: this.modifiedPlan[i].Comment,
        });
      }
      this.updateRules({ id: this.$route.params.id, rules: dataRules })
        .then(() => {
          this.$flash_success('Изменения успешно сохранены');
        })
        .catch((message) => {
          if (message.length > 0) {
            for (let i = 0; i < message.length; i++) {
              this.$flash_warning(message[i]);
            }
          } else {
            this.$flash_warning('Ошибка при смене плана набора');
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.setup-plan-rubetek-rv3434__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.setup-plan-rubetek-rv3434__actions--top {
  margin-bottom: 16px;
}
.setup-plan-rubetek-rv3434__actions-left,
.setup-plan-rubetek-rv3434__actions-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.setup-plan-rv3434__row-actions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  width: 100%;
  padding-left: 4px;
}

.setup-plan-rv3434__action-btn {
  width: 36px !important;
  height: 36px !important;
}

.setup-plan-rv3434__action-btn--analog {
  margin-right: 2px;
}

.setup-plan-rv3434__delete-icon {
  margin-left: 4px;
}

::v-deep .table tbody tr td:last-child {
  text-align: left !important;
}
::v-deep .dialog-border-radius {
  border-radius: 12px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.table-custom-header {
  padding: 10px !important;
  font-size: 13px !important;
  text-overflow: ellipsis;
}
.table-custom-header.wrap-text span {
  white-space: normal;
}
.table-custom-header span {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
